<template>
  <div>
    <div class='ctitle'>
    <h2>新的数学团队</h2>
    </div>
    <new-team-table :tableData="dshTeamList" ></new-team-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import newTeamTable from '@/components/newTeamTable/newTeamTable'

  export default {
    data () {
      return {

      }
    },
    computed: {
      ...mapGetters([
        'dshTeamList'
      ])
    },
    created () {
      this.$store.dispatch('actions_getNewTeamList')
    },
    components: {
      newTeamTable
    },
    methods: {

    }
  }
</script>

<style  scoped>
  .ctitle{
    height: 56px;
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// newTeamList.vue?77b52bf0